import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import LaunchIcon from '@mui/icons-material/Launch';
import { Box, Button, IconButton, Tooltip } from '@mui/material';
import { Link } from 'react-router-dom';
import { useAuthenticationService } from 'src/application/externalDependencies';
import history from 'src/history';
import { AppTitle } from 'src/web-ui/components/AppTitle';
import { LightDarkModeToggleButton } from 'src/web-ui/components/LightDarkModeToggleButton';
import { activityMapURL } from 'src/web-ui/pages';
import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()((theme) => ({
  appBar: {
    height: 56,
    borderBottom: `1px solid ${theme.palette.divider}`,
    // position: 'sticky',
    // top: 0,
    // zIndex: 100,
    backgroundColor: theme.palette.background.paper,
    // opacity: 0.96,
  },
  toolbar: {
    maxWidth: 1200,
    margin: '0 auto',
    display: 'flex',
    alignItems: 'center',
    paddingTop: theme.spacing(1),
  },
  lightDarkModeToggleButtonContainer: {
    display: 'inline-block',
    position: 'relative',
    bottom: 1,
  },
  footerContainer: {
    maxWidth: 1200,
    margin: '0 auto',
  },
  pageLink: {
    fontWeight: theme.typography.fontWeightRegular,
    fontSize: theme.typography.pxToRem(15),
    color: theme.palette.text.primary,
    textDecoration: 'none',
    marginLeft: theme.spacing(2),
    marginRight: theme.spacing(2),
  },
  hiddenOnMobile: {
    display: 'flex',
    [theme.breakpoints.down('sm')]: {
      display: 'none',
    },
  },
}));

export const PageContainerHeader = () => {
  const { classes } = useStyles();
  const { login, isAuthenticated } = useAuthenticationService();

  const handleGoToAccount = () => {
    history.push('/account');
  };

  const handleLogin = () => {
    login({ returnTo: activityMapURL });
  };

  const handleSignUp = () => {
    login({ type: 'signup', returnTo: activityMapURL });
  };

  return (
    <Box flexGrow={1} alignItems="center" className={classes.appBar}>
      <Box className={classes.toolbar}>
        <Box mr={2} ml={1}>
          <AppTitle />
        </Box>
        <Box component="span" className={classes.hiddenOnMobile}>
          <Link to={activityMapURL} className={classes.pageLink}>
            Dashboards
          </Link>
          <Link to="/plans" className={classes.pageLink}>
            Plans
          </Link>
          <Link to="/our-data" className={classes.pageLink}>
            Our Data
          </Link>
          <Box
            component={'a'}
            href="https://stackdx.com?source=intel"
            target={'_blank'}
            className={classes.pageLink}
            sx={{ display: 'flex', alignItems: 'center' }}
          >
            StackDX <LaunchIcon fontSize={'small'} sx={{ ml: 1 }} />
          </Box>
        </Box>

        <Box flexGrow={1} />
        <>
          {!isAuthenticated && <Button onClick={handleSignUp}>Sign up</Button>}
          {!isAuthenticated && <Button onClick={handleLogin}>Login</Button>}
          {isAuthenticated && (
            <Box mr={1} display="inline-block">
              <Tooltip title="My account">
                <IconButton aria-label="account" onClick={handleGoToAccount}>
                  <AccountCircleIcon />
                </IconButton>
              </Tooltip>
            </Box>
          )}

          <Box className={classes.lightDarkModeToggleButtonContainer} mr={1}>
            <LightDarkModeToggleButton />
          </Box>
        </>
      </Box>
    </Box>
  );
};
